import React, { Component } from 'react';
import LoadingCube from 'sub_components/Common/LoadingCube';
import PermissionSelector from './Components/PermissionSelector';

class SitePermissions extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedModule: 'Account',
		};
	}

	render() {
		const {
			pages,
			selected,
			setSelected,
			auth_status,
			company_info,
			selectedId,
			user,
			setModalContent,
			error,
			pagesLoaded,
			module,
			organizationId,
			usersRole,
			reloadPermissions,
			hasUserPermissionEditAccess,
		} = this.props;

		return (
			<div className='site-permissions-container'>
				{pagesLoaded && (
					<div className='permission-selection'>
						<PermissionSelector
							usersRole={usersRole}
							callback={setSelected}
							error={error}
							selectedModule={selected}
							pages={pages}
							pagesLoaded={pagesLoaded}
							auth_status={auth_status}
							company_info={company_info}
							organizationId={organizationId}
							selectedId={selectedId}
							user={user}
							setModalContent={setModalContent}
							module={module}
							reloadPermissions={reloadPermissions}
							hasUserPermissionEditAccess={hasUserPermissionEditAccess}
						/>
					</div>
				)}
				{!pagesLoaded && <LoadingCube />}
			</div>
		);
	}
}

export default SitePermissions;
